import React from 'react';
import { useNavigate } from 'react-router-dom';

function YurtdisiPage() {
  const navigate = useNavigate();

  const markets = [
    { name: "NYSE", description: "New York Borsası", icon: "🇺🇸" },
    { name: "NASDAQ", description: "Teknoloji Ağırlıklı Borsa", icon: "💻" },
    { name: "LSE", description: "Londra Borsası", icon: "🇬🇧" },
    { name: "DAX", description: "Almanya Borsası", icon: "🇩🇪" }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Yurtdışı Piyasalar</h1>
          <div className="w-6"></div>
        </div>
      </header>

      <div className="max-w-6xl mx-auto py-12 px-4">
        <div className="bg-white rounded-lg shadow-md p-8 mb-8">
          <h2 className="text-3xl font-bold text-[#1e5a8e] mb-4">Uluslararası Piyasalar</h2>
          <p className="text-gray-600 leading-relaxed">
            Dünya borsalarında işlem yapma imkanı. ABD, Avrupa ve Asya piyasalarında 
            hisse senedi alım satımı yapabilirsiniz.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {markets.map((market, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow">
              <div className="text-4xl mb-3">{market.icon}</div>
              <h3 className="font-bold text-[#1e5a8e] mb-2">{market.name}</h3>
              <p className="text-gray-600 text-sm">{market.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#1e5a8e] to-[#26c6da] rounded-lg shadow-lg p-8 text-white">
          <h3 className="text-2xl font-bold mb-4">Global İşlem Fırsatları</h3>
          <ul className="space-y-3 mb-6">
            <li className="flex items-center gap-2">
              <span>✓</span> Dünya devlerinin hisselerine erişim
            </li>
            <li className="flex items-center gap-2">
              <span>✓</span> Çeşitlendirilmiş portföy imkanı
            </li>
            <li className="flex items-center gap-2">
              <span>✓</span> Güvenli ve hızlı işlem
            </li>
          </ul>
          <button 
            onClick={() => navigate('/login')}
            className="px-8 py-3 bg-white text-[#1e5a8e] rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Hesap Aç
          </button>
        </div>
      </div>
    </div>
  );
}

export default YurtdisiPage;
